import Constants from '../constants/action'

export const toggleNotificationCentre = () => ({
  type: Constants.NOTIFICATION_CENTRE_TOGGLE,
})
